<template>
    <h1>Ups! No s'ha trobat la pàgina!</h1>
</template>

<script>
    export default {
        name: "NotFoundView"
    }
</script>

<style scoped>

</style>